import { render, staticRenderFns } from "./SpecialtyInformationAddEdit.vue?vue&type=template&id=05c82ba6&scoped=true"
import script from "./SpecialtyInformationAddEdit.vue?vue&type=script&lang=js"
export * from "./SpecialtyInformationAddEdit.vue?vue&type=script&lang=js"
import style0 from "./SpecialtyInformationAddEdit.vue?vue&type=style&index=0&id=05c82ba6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c82ba6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05c82ba6')) {
      api.createRecord('05c82ba6', component.options)
    } else {
      api.reload('05c82ba6', component.options)
    }
    module.hot.accept("./SpecialtyInformationAddEdit.vue?vue&type=template&id=05c82ba6&scoped=true", function () {
      api.rerender('05c82ba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/practitionerIntern/components/SpecialtyInformation/SpecialtyInformationAddEdit.vue"
export default component.exports